import Axios from "axios";

const ApiDomain = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? "http://localhost:8080/api/data" : "/api/data";

const getData = (callback, failCallback) => {
  Axios.get(ApiDomain).then(callback).catch(failCallback);
};

export default getData;